import React, {PureComponent} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import Provider from "pubsub-js";
import {CANVAS} from "../../constants";
import {
  APPLY_BACKGROUND,
  CANVAS_MODIFIED,
  SCALLED_UP_IMAGES
} from "../../constants/event-types";
import {
  productSelector,
  conditionSelector,
  messageSelector
} from "../../selectors";
import withMobileContext from "../../decorators/withMobileContext";
import {initCanvas as initCanvasAC} from "../../AC/init-canvas";
import {applyConditionToCanvas as applyConditionToCanvasAC} from "../../AC/apply-condition-to-canvas";
import {addMessage as addMessageAC} from "../../AC/add-message";
import {changeDesign} from "../../AC/change-design";
import {autoSaveDesign} from "../../AC/auto-save-design";
import Loader from "../../../common/Loader";
import Canvas from "./Canvas";
import Messages from "./Messages";
import ObjectContextMenu from "./ObjectContextMenu";
import ContextMenu from "./ContextMenu";
import KeyObserver from "./KeyObserver";
import AngleLabel from "./AngleLabel";
import Mediator from "../../services/Mediator";
import {selectionModeSelect} from "../../reducer/selectionMode";

class Product extends PureComponent {
  static propTypes = {
    id: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    product: PropTypes.shape({
      meta: PropTypes.object,
      loading: PropTypes.bool,
      loaded: PropTypes.bool
    }),
    message: PropTypes.shape({
      warning: PropTypes.string,
      info: PropTypes.string
    }),
    condition: PropTypes.object,
    initCanvas: PropTypes.func,
    applyConditionToCanvas: PropTypes.func,
    changeDesign: PropTypes.func,
    autoSaveDesign: PropTypes.func,
    addMessage: PropTypes.func,
    changeVariant: PropTypes.func,
    isMobile: PropTypes.bool
  };
  state = {
    background: ``,
    disableContextMenu: true,
    hasScaledUpImages: false
  };
  componentDidMount() {
    const {initCanvas, applyConditionToCanvas, isMobile} = this.props;
    const {ID: id, WIDTH: width, HEIGHT: height} = CANVAS;

    initCanvas({id, width, height, isMobile});
    applyConditionToCanvas();
    this.initListeners();
    this.touchStartHandler = this.touchStartHandler.bind(this)
    this.touchEndHandler = this.touchEndHandler.bind(this)
  }
  componentDidUpdate(prevProps) {
    const {condition: prevCondition} = prevProps;
    const {condition: nextCondition, applyConditionToCanvas} = this.props;
    if (
      prevCondition.product !== nextCondition.product ||
      JSON.stringify({
        ...prevCondition,
        design: ``
      }) ===
        JSON.stringify({
          ...nextCondition,
          design: ``
        })
    ) {
      return;
    }
    // apply condition only when changed variants and side
    applyConditionToCanvas(prevCondition);
  }
  componentWillUnmount() {
    Provider.clearAllSubscriptions();
  }
  initListeners() {
    Provider.subscribe(APPLY_BACKGROUND, (_, background) => {
      this.setState({
        background
      });
    });
    Provider.subscribe(CANVAS_MODIFIED, (_, newDesign) => {
      const {
        product: {
          meta: {designs}
        },
        condition: {side}
      } = this.props;
      const sideIndex = designs.reduce(
        (acc, item, i) => (item.side === side ? i : acc),
        0
      );
      this.props.changeDesign(side, newDesign, sideIndex);
    });
    Provider.subscribe(
      SCALLED_UP_IMAGES,
      (_, {result: hasScaledUpImages, list}) => {
        const {addMessage} = this.props;
        const notJustShutterstock = list.find(
          (item) => item.fields && !item.fields.isShutterstockImage
        );
        if (
          !this.state.hasScaledUpImages &&
          hasScaledUpImages &&
          notJustShutterstock
        ) {
          addMessage(
            `warning`,
            `Превышен размер картинки (возможен размытый результат)`
          );
          this.setState({
            hasScaledUpImages
          });
        } else if (this.state.hasScaledUpImages && !hasScaledUpImages) {
          addMessage(`warning`, ``);
          this.setState({
            hasScaledUpImages
          });
        }
      }
    );
  }
  touchMoveScrollDisable(e) {
    e.preventDefault()
  }
  touchStartHandler(e) {
    if (!this.props.selectionMode) return

    const pointer = e.touches[0]
    const canvas = document.getElementById(CANVAS.ID)
    const {left, top} = canvas.getBoundingClientRect()
    const scaleFactor = window.innerWidth > CANVAS.WIDTH ? 1 : CANVAS.WIDTH / window.innerWidth

    Mediator.setSelectionMode(true)
    document.body.addEventListener('touchmove', this.touchMoveScrollDisable, {passive: false})

    Mediator.getCanvas()._groupSelector = {
      ex: (pointer.clientX - left) * scaleFactor,
      ey: (pointer.clientY - top) * scaleFactor,
      top: 0,
      left: 0
    }
  }
  touchEndHandler() {
    setTimeout(() => {
      Mediator.setSelectionMode(false)
      document.body.removeEventListener('touchmove', this.touchMoveScrollDisable)
    })
  }
  render() {
    const {
      message,
      product: {loading, loaded},
      isMobile
    } = this.props;
    const {background} = this.state;
    return (
      <div className={`product${loading && !loaded ? ` product_loading` : ``}`} onTouchStart={this.touchStartHandler} onTouchEnd={this.touchEndHandler}>
        <Canvas background={background} />
        <Messages message={message} />
        {!isMobile && <ObjectContextMenu />}
        {!isMobile && <ContextMenu />}
        <KeyObserver />
        <AngleLabel />
        {loading && !loaded && <Loader />}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  product: productSelector(state),
  condition: conditionSelector(state),
  message: messageSelector(state),
  selectionMode: selectionModeSelect(state),
});

export default connect(mapStateToProps, {
  initCanvas: initCanvasAC,
  applyConditionToCanvas: applyConditionToCanvasAC,
  addMessage: addMessageAC,
  changeDesign,
  autoSaveDesign
})(withMobileContext(Product));
